"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDifficulty = exports.valuesArrayToHeaderData = exports.numberToHex = void 0;
const util_1 = require("@ethereumjs/util");
/**
 * Returns a 0x-prefixed hex number string from a hex string or string integer.
 * @param {string} input string to check, convert, and return
 */
const numberToHex = function (input) {
    if (input === undefined)
        return undefined;
    if (!(0, util_1.isHexString)(input)) {
        const regex = new RegExp(/^\d+$/); // test to make sure input contains only digits
        if (!regex.test(input)) {
            const msg = `Cannot convert string to hex string. numberToHex only supports 0x-prefixed hex or integer strings but the given string was: ${input}`;
            throw new Error(msg);
        }
        return '0x' + parseInt(input, 10).toString(16);
    }
    return input;
};
exports.numberToHex = numberToHex;
function valuesArrayToHeaderData(values) {
    const [parentHash, uncleHash, coinbase, stateRoot, transactionsTrie, receiptTrie, logsBloom, difficulty, number, gasLimit, gasUsed, timestamp, extraData, mixHash, nonce, baseFeePerGas,] = values;
    if (values.length > 16) {
        throw new Error('invalid header. More values than expected were received');
    }
    if (values.length < 15) {
        throw new Error('invalid header. Less values than expected were received');
    }
    return {
        parentHash,
        uncleHash,
        coinbase,
        stateRoot,
        transactionsTrie,
        receiptTrie,
        logsBloom,
        difficulty,
        number,
        gasLimit,
        gasUsed,
        timestamp,
        extraData,
        mixHash,
        nonce,
        baseFeePerGas,
    };
}
exports.valuesArrayToHeaderData = valuesArrayToHeaderData;
function getDifficulty(headerData) {
    const { difficulty } = headerData;
    if (difficulty !== undefined) {
        return (0, util_1.toType)(difficulty, util_1.TypeOutput.BigInt);
    }
    return null;
}
exports.getDifficulty = getDifficulty;
//# sourceMappingURL=helpers.js.map